export const BRANDS = {
  WE: {
    hostUrl: "https://www.westelm.com/",
    name: "West Elm",
  },
  PK: {
    hostUrl: "https://www.potterybarnkids.com/",
    name: "Pottery Barn Kids",
  },
  PT: {
    hostUrl: "https://www.pbteen.com/",
    name: "Pottery Barn Teen",
  },
  PB: {
    hostUrl: "https://www.potterybarn.com/",
    name: "Pottery Barn",
  },
  WS: {
    hostUrl: "https://www.williams-sonoma.com/",
    name: "Williams Sonoma",
  },
  // MG: {
  //     hostUrl : "https://www.potterybarnkids.com/",
  //     name: "Mark and Grahams"
  // }
};
export const TAB_STATUSES = {
  APPROVED: "APPROVED",
  PENDING_CHANGES: "PENDING_CHANGES",
  IN_PROGRESS: "IN_PROGRESS",
};
export const singleColors = [
  "#E666B3",
  "#4DB380",
  "#6666FF",
  "#B3B31A",
  "#FF3380",
  "#4D80CC",
  "#33991A",
  "#CC9999",
  "#00E680",
  "#4D8066",
  "#809980",
  "#E6FF80",
  "#1AFF33",
  "#999933",
  "#CCCC00",
  "#66E64D",
  "#9900B3",
  "#E64D66",
  "#FF4D4D",
  "#99E6E6",
];
export const multipleColors = [
  "#FF6633",
  "#FFB399",
  "#FF33FF",
  "#FFFF99",
  "#00B3E6",
  "#E6B333",
  "#3366E6",
  "#999966",
  "#99FF99",
  "#B34D4D",
  "#80B300",
  "#809900",
  "#E6B3B3",
  "#6680B3",
  "#66991A",
  "#FF99E6",
  "#CCFF1A",
  "#FF1A66",
  "#E6331A",
  "#33FFCC",
  "#66994D",
  "#B366CC",
  "#4D8000",
  "#B33300",
  "#CC80CC",
  "#66664D",
  "#991AFF",
  "#E666FF",
  "#4DB3FF",
  "#1AB399",
];

export const WSI_ML_SIMILARITY_ENDPOINT = `ml-visual-search/similarity`;
export const WSI_ML_EMBEDDINGS_ENDPOINT = `ml-visual-search/embeddings`;
export const WSI_ML_YOLO_ENDPOINT = `ml-visual-search/yolo`;
export const WSI_ML_NLP_ENDPOINT = `ml-visual-search/nlp`;
